import { AXIS_HEIGHT, CONTEXT_VALUES_HEIGHT_OFFSET } from '../constants.js';

export const getSparklineHeight = (
  containerHeight: number,
  showTicks: boolean,
  showContextMin: boolean,
  showContextMax: boolean,
) => {
  let height = showTicks ? containerHeight - AXIS_HEIGHT : containerHeight;

  if (showContextMin || showContextMax) {
    height -= CONTEXT_VALUES_HEIGHT_OFFSET;
  }
  if (showContextMin && showContextMax) {
    height -= CONTEXT_VALUES_HEIGHT_OFFSET;
  }

  return Math.max(0, height);
};
